import { createAction } from 'redux-actions';

import {
  CUSTOMER_DATA_FETCH,
  CUSTOMER_DATA_FETCH_SUCCESS,
  CUSTOMER_DATA_UPDATE,
  CUSTOMER_DATA_UPDATE_FINISHED,
} from './constants'

export const updateCustomer = createAction(CUSTOMER_DATA_UPDATE);


export const updateCustomerFinished = createAction(CUSTOMER_DATA_UPDATE_FINISHED)

export const fetchCustomerData = createAction(CUSTOMER_DATA_FETCH);

export const fetchCustomerDataSuccess = createAction(CUSTOMER_DATA_FETCH_SUCCESS, (data) => ({
  data,
}));
